module.exports = __webpack_public_path__ + "static/media/user.8feff939.png";